import { css, Theme } from '@emotion/react';

import { mainModalCompactHeightMediaQuery, mainModalSmallScreenMediaQuery } from './mainModalCompact.constants';

export const styles = {
  Root: (theme: Theme) => css`
    --gutter: var(--main-modal-gutter, 24px);

    display: flex;
    flex-direction: column;

    margin: auto;
    padding: 24px var(--gutter) 24px;
    max-width: var(--main-modal-width, 781px);
    width: calc(100% - 32px);
    height: auto;
    max-height: calc(100vh - 48px);

    border-radius: 8px;
    background: white;
    padding-top: 38px;
    padding-bottom: 38px;

    ${ theme.breakpoints.down('xxl') } {
      max-width: var(--main-modal-width, 752px);
    }

    ${ theme.breakpoints.down('sm') } {
      --gutter: 34px;

      width: 100%;
      height: 100%;
      max-height: 100%;
      border-radius: 0;
    }

    @media (max-height: 800px) {
      --gutter: 24px;
    }

    @media (max-height: 650px) {
      max-height: 100%;
    }

    @media ${ mainModalCompactHeightMediaQuery } {
      min-height: 0;
    }

    @media ${ mainModalSmallScreenMediaQuery } {
      min-height: 0;
      /* Footer carries its own padding; avoid stacking with default 38px bottom padding */
      padding-bottom: 8px;
    }
  `,
  Header: css`
    flex-shrink: 0;
  `,
  Content: (isScrollable: boolean) => css`
  display: flex;
  flex-direction: column;
  margin: 0 calc(-1 * var(--gutter)) 0;
  padding: 24px var(--gutter) 4px;
  height: 100%;
  overflow-y: ${ isScrollable ? 'auto' : 'visible' };
  position: relative;

  @media (max-height: 800px) {
    padding: 12px var(--gutter) 4px;
  }

  @media ${ mainModalCompactHeightMediaQuery }, ${ mainModalSmallScreenMediaQuery } {
    flex: 1 1 auto;
    min-height: 0;
    height: auto;
    overflow-y: ${ isScrollable ? 'auto' : 'visible' };
    padding-bottom: 12px;
  }
`,
  /** Pinned action region; visible on small-screen viewports (see constant). */
  Footer: css`
    display: none;

    @media ${ mainModalSmallScreenMediaQuery } {
      display: block;
      flex-shrink: 0;
      box-sizing: border-box;
      width: calc(100% + 2 * var(--gutter));
      margin: 0 calc(-1 * var(--gutter)) 0;
      padding: 6px 6px max(6px, env(safe-area-inset-bottom, 0px));
      border-top: 1px solid rgba(0, 0, 0, 0.08);
      background: rgba(255, 255, 255, 0.94);
      backdrop-filter: blur(10px);
      z-index: 2;
    }
  `,
};
